import { IListResponse } from 'Shared/Types/api';
import { client } from 'Service/axios';
import { ILoad, ILoadStatuses } from 'Shared/Types/load';

const LOADS_URL = 'orders/my_loads/';

class Load {
  getLoadList({
    page,
    pageSize,
    category,
  }: {
    page?: number;
    pageSize?: number;
    category?: string;
  }) {
    return client.get<IListResponse<ILoad[]>>(
      `${LOADS_URL}${category ? category + '/' : ''}`,
      {
        params: {
          page,
          page_size: pageSize,
        },
      },
    );
  }

  getLoad(id: number) {
    return client.get<ILoad>(`${LOADS_URL}${id}`);
  }

  setNextLoadStatus(data: { order_id: number }) {
    return client.post<ILoadStatuses>(`${LOADS_URL}next_status/`, data);
  }

  setPrevLoadStatus(data: { order_id: number }) {
    return client.post<ILoadStatuses>(`${LOADS_URL}previous_status/`, data);
  }
}

export default Load;
